<template>
  <div class="ncnp-entry">
    <div class="ncnp-card">
      <h2>国家算力一体化平台 · 统一登录入口</h2>
      <p class="hint">点击下方按钮跳转到国家平台完成授权登录，登录后可继续在长三角算力公共服务平台浏览订购。</p>
      <el-button type="primary" :loading="loading" @click="goAuthorize">前往国家平台登录</el-button>
      <p class="meta">已登录用户：<span>{{ loginSourceLabel }}</span></p>
    </div>
  </div>
</template>

<script>
import { startNcnpAuthorize } from "@/utils/ncnp";

export default {
  name: "NcnpEntry",
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    loginSourceLabel() {
      const src = this.$store.state.user.loginSource;
      if (src === "NCNP") return "国家平台账号已登录";
      if (src) return src;
      return "未登录";
    },
  },
  methods: {
    async goAuthorize() {
      this.loading = true;
      try {
        // 入参 redirect 一律收口为站内路径；订购流程跳本地 /orders/place?goods_id=
        const rawRedirect = this.$route.query.redirect || "/compute";
        const ok = await startNcnpAuthorize(rawRedirect);
        // 成功时 startNcnpAuthorize 已 window.location 跳走，不会回到这里
        if (!ok) {
          this.$message.error("获取授权地址失败");
        }
      } catch (e) {
        this.$message.error("跳转国家平台登录失败");
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.ncnp-entry {
  min-height: 60vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f6f8fb;
}

.ncnp-card {
  width: 480px;
  padding: 36px 32px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(22, 119, 255, 0.08);
  text-align: center;

  h2 {
    margin: 0 0 16px;
    font-size: 22px;
    color: #1d2129;
  }

  .hint {
    color: #4e5969;
    margin-bottom: 24px;
    line-height: 1.6;
  }

  .meta {
    margin-top: 18px;
    font-size: 12px;
    color: #86909c;
    span {
      color: #1677ff;
    }
  }
}
</style>
